import { Injectable } from '@angular/core';
import { FolderModel } from '../../../../core/models/resources/folder.model';
import { HttpService } from '../http-service/http.service';
import { ResourceContentService } from '../content/resource-content.service';
import { ServiceModule } from '../../../service.module';

@Injectable({ providedIn: ServiceModule })
export class FolderService extends ResourceContentService<FolderModel> {
    constructor(protected override httpService: HttpService<FolderModel>) {
        super(httpService);
    }

    getResourceUrl(): string {
        return 'folders';
    }
}
